import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getKeyTypes } from './api';
import type { GetKeyTypesResponse } from './types';

export const KeyTypesControlGate = createGate();

const fxGetKeyTypes = createEffect<void, GetKeyTypesResponse, Error>().use(getKeyTypes);

export const keyTypesQuery = createQuery({
  name: 'KeyTypes',
  effect: fxGetKeyTypes,
  mapData: ({ result }) =>
    Array.isArray(result?.type)
      ? result.type.map((item) => ({
          id: item?.id,
          label: item?.title ?? '',
        }))
      : [],
});

sample({
  clock: KeyTypesControlGate.open,
  source: KeyTypesControlGate.status,
  filter: (status) => Boolean(status),
  target: keyTypesQuery.start,
});
